import type en from './en';

const fr: typeof en = {
  chatMeeting: {
    prompt: '{{name}} a proposé une rencontre. On accepte ?',
    yes: 'Oui, proposer des créneaux',
    decline: 'Décliner',
    notInterested: 'Pas intéressé·e',
    error: "Impossible d'enregistrer. Réessayez.",
  },
  join: {
    title: 'Vous avez accès à une Secrétaire IA',
    titleThanks: '(grâce à {{name}})',
    scanQr:
      'Scannez le QR code avec votre téléphone pour démarrer une conversation WhatsApp avec votre nouvelle secrétaire.',
    fromThere:
      'Vous pourrez ensuite configurer votre compte et confier votre administratif à votre secrétaire !',
    openWhatsApp: 'Ouvrir WhatsApp',
    inviteOnlyTitle: "Dream est sur invitation uniquement pour l'instant.",
    invalidBody:
      "Ce lien d'invitation n'est pas valide — il a peut-être été mal saisi ou n'est plus actif. Demandez un nouveau lien à la personne qui vous a invité, ou inscrivez-vous sur notre liste d'attente et nous vous recontacterons.",
    joinWaitlist: "Rejoindre la liste d'attente",
    loading: 'Chargement',
  },
  connect: {
    statusAlreadyConnected:
      'Ce compte est déjà connecté. Vous pouvez ajouter un autre compte ci-dessous.',
    statusExpired:
      'Ce lien a expiré. Veuillez demander un nouveau lien à votre secrétaire.',
    statusInvalidToken:
      "Ce lien n'est pas valide. Veuillez demander un nouveau lien à votre secrétaire.",
    statusAlreadyLinkedOther:
      'Ce compte est déjà associé à un autre compte Dream.',
    statusError:
      "Nous n'avons pas pu charger votre page de connexion. Veuillez réessayer.",
    missingToken:
      "Jeton d'onboarding manquant. Veuillez ouvrir cette page depuis WhatsApp.",
    loadAccountsError:
      'Impossible de charger vos comptes connectés pour le moment.',
    disconnectError: 'Impossible de déconnecter ce compte.',
    yourAccount: 'Votre compte',
    title: 'Connectez votre compte',
    body1:
      'Connectez votre e-mail et votre agenda pour que votre secrétaire puisse suivre vos tâches et repérer les conflits de calendrier.',
    body2: "Il n'enverra jamais d'e-mail depuis votre compte.",
    allDone: 'Terminé ?',
    youCan: 'Vous pouvez',
    returnToWhatsApp: 'retourner sur WhatsApp',
    keepConnecting: ', ou continuer à connecter des comptes',
    loadingAccounts: 'Chargement de vos comptes connectés…',
    connectedAccount: 'Compte connecté',
    disconnectAria: 'Déconnecter {{account}}',
    thisAccount: 'ce compte',
    connectGoogle: 'Connecter votre compte Google',
    connectAnotherGoogle: 'Connecter un autre compte Google',
    connectOutlook: 'Connecter votre compte Outlook',
    connectAnotherOutlook: 'Connecter un autre compte Outlook',
    disclaimer:
      'Nous prenons en charge les comptes Gmail, Google Workspace et Outlook.',
  },
  travelOptions: {
    title: 'Options de voyage',
    eyebrow: 'Votre voyage',
    tabs: 'Options de voyage',
    flights: 'Vols',
    hotels: 'Hébergements',
    trains: 'Trains',
    flight: 'Vol',
    hotel: 'Hébergement',
    train: 'Train',
    removeTask: 'Supprimer la tâche',
    book: 'Réserver',
    bookWithDream: 'Réserver avec Dream',
    separateTickets: 'Billets séparés',
    separateTicketsWarning:
      'Ces vols sont réservés séparément. Vérifiez le temps de correspondance et prévoyez les retards.',
    seeReturnTimes: 'Voir les horaires retour',
    otherReturnTimes: 'Autres horaires retour ({{count}})',
    bookBothFlights: 'Réserver les deux vols',
    viewStay: 'Voir l’hébergement',
    loading: 'Chargement des options de voyage…',
    close: 'Fermer',
    outbound: 'Aller',
    return: 'Retour',
    returnsErrorTitle: "Nous n'avons pas pu charger vos vols retour",
    returnsErrorBody:
      "Réessayez ou revenez en arrière pour voir d'autres options",
    returnsRateLimited:
      'Trop de demandes sur cette page. Attendez quelques minutes.',
    tryAgain: 'Réessayer',
    back: 'Retour',
    returnRefreshCountdown: 'Les prix seront mis à jour dans {{time}}',
    flightUnavailable: 'Ce vol n’est plus disponible. Choisissez-en un autre.',
    gettingLivePricesButton: 'Mise à jour des prix…',
    flightBookingPending:
      'Je réserve {{time}} pour {{place}}. Je vous préviendrai quand ce sera fait.',
    flightBookingConfirmed:
      'J’ai réservé {{time}} pour {{place}} le {{date}}.{{reference}}',
    flightBookingUnknown:
      'Je vérifie si {{time}} pour {{place}} est bien passé. Je vous préviendrai.',
    flightBookingNotBooked:
      'Je n’ai pas pu réserver {{time}} pour {{place}}. Je vous écrirai pour vous dire quoi faire ensuite.',
    hotelBookingPending:
      'Je réserve {{name}}. Je vous préviendrai quand ce sera fait.',
    hotelBookingConfirmed: 'J’ai réservé {{name}}.{{reference}}',
    hotelBookingUnknown:
      'Je vérifie si {{name}} est bien passé. Je vous préviendrai.',
    hotelBookingNotBooked:
      'Je n’ai pas pu réserver {{name}}. Je vous écrirai pour vous dire quoi faire ensuite.',
    sameTicket: 'Même billet',
    confirmBooking: 'Confirmer la réservation',
    traveller: 'Voyageur',
    sort: {
      label: 'Trier par',
      recommended: 'Recommandé',
      price: 'Prix',
      departure: 'Heure de départ',
      arrival: 'Heure d’arrivée',
      duration: 'Durée',
      rating: 'Note',
    },
  },
  suggestions: {
    loading: 'Chargement…',
    linkExpiredTitle: 'Lien expiré',
    somethingOffTitle: 'Un problème est survenu',
    expiredBody:
      'Ce lien a expiré. Demandez à votre secrétaire sur WhatsApp et elle vous en enverra un nouveau.',
    invalidBody:
      'Ce lien n’est pas valide. Veuillez ouvrir le lien depuis votre conversation WhatsApp.',
    errorBody:
      'Une erreur est survenue lors du chargement de cette page. Veuillez réessayer dans un instant.',
    fromAssistantNamed: 'De {{name}}, votre secrétaire',
    fromAssistant: 'De votre secrétaire',
    titleLead: 'On',
    titleAccent: 'commence',
    coverCopy:
      'Six choses qu’on me confie chaque semaine — de vrais exemples, de vrais utilisateurs. Choisissez-en une et je prends le relais.',
    swipeUp: 'Balayez vers le haut',
    picked: 'Choisi — je reviens vers vous',
    swipeNext: 'Balayez pour voir la suivante',
    thatsTheLot: 'C’est tout — choisissez-en une ✦',
  },
  tour: {
    carouselAria: 'Les nouveautés de Dream',
    whatsNew: 'Nouveautés',
    ofCount: '{{n}} sur {{total}}',
    previous: 'Précédent',
    startExploring: 'Découvrir',
    showMeAfter: 'Montrez-moi après',
    addedAfterList: 'Super, je vous en parlerai',
    addedForWhatsApp: 'Ajouté — je vous en reparle sur WhatsApp',
    added: 'Ajouté',
    notInterested: 'Cela ne m’intéresse pas',
    okThanks: 'Ok, merci',
    doneTitle: 'À tout de suite sur WhatsApp',
    doneBody:
      'Je reviens vers vous dans notre conversation pour tout ce qui vous a intéressé. Vous pouvez fermer cette page.',
    openWhatsApp: 'Retour sur WhatsApp',
    linkExpiredTitle: 'Ce lien a expiré',
    somethingOffTitle: 'Quelque chose ne va pas',
    expiredBody:
      'Ce lien n’est plus actif. Écrivez simplement à votre secrétaire sur WhatsApp pour lui demander les nouveautés.',
    invalidBody:
      'Ce lien n’est pas valide. Veuillez ouvrir le lien depuis votre conversation WhatsApp.',
    errorBody: 'Une erreur s’est produite. Veuillez réessayer dans un instant.',
    scenes: {
      summary: {
        name: 'Récapitulatif',
        headline: 'Voilà les nouveautés',
        tail: 'pour le moment.',
        line: 'Je reviens vers vous sur WhatsApp pour tout ce qui est coché.',
      },
      intro: {
        name: 'Introduction',
        headline: '{{name}} a',
        tail: 'de nouvelles compétences.',
        line: 'Voici {{count}} nouveautés de {{name}} à essayer.',
      },
      scheduling: {
        name: 'Planification',
        headline: 'Ne courez plus',
        tail: 'après un créneau de réunion.',
        line: 'Dites-moi qui vous devez voir et à peu près quand. Je conviens d’un horaire avec eux et je l’ajoute à votre agenda.',
        topic: 'la prise de rendez-vous',
      },
      assistants: {
        name: 'De secrétaire à secrétaire',
        headline: 'Des réunions entre collègues,',
        tail: 'réglées entre secrétaires.',
        line: 'S’ils utilisent aussi Dream, nos secrétaires fixent l’horaire entre elles. Seule la planification est partagée — rien d’autre de votre agenda.',
        topic: 'les échanges avec les secrétaires des autres',
      },
      shop: {
        name: 'Courses de la semaine',
        headline: 'Vos courses Ocado,',
        tail: 'planifiées et dans le panier.',
        line: 'Connectez Ocado et dites-moi à quoi ressemble la semaine. Je prévois les repas, je remplis le panier et je vérifie avec vous avant de valider.',
        topic: 'vos courses Ocado de la semaine',
      },
      email: {
        name: 'E-mails sur WhatsApp',
        headline: 'Répondez à vos e-mails',
        tail: 'sans les ouvrir.',
        line: 'Je rédige des réponses dans votre style et je vous les montre ici. Appuyez sur Envoyer, ou ouvrez le brouillon pour le modifier d’abord.',
        topic: 'les réponses aux e-mails depuis WhatsApp',
      },
      check_in: {
        name: 'Point du soir',
        headline: 'Un court point',
        tail: 'à 19 h.',
        line: 'Ce qui a été fait aujourd’hui, ce qui reste ouvert et à quoi ressemble demain — pour que rien ne passe à la trappe.',
        topic: 'le point de 19 h',
      },
      organisations: {
        name: 'Organisations',
        headline: 'Apportez Dream',
        tail: 'à votre entreprise.',
        line: 'Déployez Dream pour toute votre équipe. Ajoutez des secrétaires pour vos collaborateurs clés, le tout facturé sur une seule carte — et je les aide à démarrer.',
        topic: 'Dream pour votre organisation',
      },
    },
  },
  briefing: {
    linkExpiredTitle: 'Cette liste est fermée',
    somethingOffTitle: 'Quelque chose ne va pas',
    expiredBody:
      'Cette Morning List date d’un jour précédent. Tout ce qui reste ouvert reviendra — ou écrivez simplement à votre secrétaire sur WhatsApp.',
    invalidBody:
      'Ce lien n’est pas valide. Veuillez ouvrir le lien depuis votre conversation WhatsApp.',
    errorBody: 'Une erreur s’est produite. Veuillez réessayer dans un instant.',
    brandAria: 'Dream',
    listAria: 'Votre briefing',
    navAria: 'Navigation du briefing',
    optionsAria: 'Actions pour cet élément',
    chooseAnother: 'Choisir une autre action',
    openDraft: 'Ouvrir le brouillon',
    copyDraft: 'Copier le brouillon',
    copied: 'Copié',
    openLinkedin: 'Ouvrir dans LinkedIn',
    openWhatsapp: 'Ouvrir WhatsApp',
    draftOnMac: 'Aussi dans WhatsApp sur votre Mac',
    notRelevant: 'Pas pertinent',
    notRelevantAria: 'Ce n’est pas pertinent',
    chosen: 'Choisi : {{label}}',
    next: 'Suivant',
    seeList: 'Voir votre liste de tâches',
    previous: 'Élément précédent',
    whyPrompt:
      'Vous avez déjà passé des éléments comme « {{headline}} ». Un mot sur la raison m’aide à ne plus les proposer.',
    whyPlaceholder: 'Pourquoi n’est-ce pas pertinent ?',
    whySkip: 'Passer',
    whySend: 'Envoyer',
    whyThanks: 'Merci — c’est noté.',
    todosAria: 'Vos tâches',
    today: 'Aujourd’hui',
    tomorrow: 'Demain',
    weekAria: 'Choisir un jour',
    nothingPlanned: 'Rien de prévu.',
    clearDay: 'Journée libre.',
    clearDayName: 'Journée libre, {{name}}.',
    nothingDueToday: 'Rien à faire aujourd’hui.',
    getAhead: 'Prendre de l’avance',
    noDate: 'Sans date',
    doToday: 'Faire aujourd’hui',
    doTodayAria: 'Faire {{title}} aujourd’hui',
    spottedInEmail: 'Repéré dans vos e-mails',
    spottedCount_one: '{{count}} chose que vous pourriez vouloir ajouter',
    spottedCount_other: '{{count}} choses que vous pourriez vouloir ajouter',
    sinceDay: 'depuis {{day}}',
    dueToday: 'Pour aujourd’hui',
    dueTomorrow: 'Pour demain',
    dueOn: 'Pour le {{date}}',
    addToToday: 'Ajouter à aujourd’hui',
    addToTomorrow: 'Ajouter à demain',
    addFor: 'Ajouter pour le {{date}}',
    addToCalendar: 'Ajouter au calendrier',
    addedToTomorrow: 'Ajouté à demain.',
    addedFor: 'Ajouté pour le {{date}}.',
    addedToCalendar: 'Ajouté à votre calendrier.',
    addedToCalendarAt: 'Dans votre calendrier : {{date}}, {{time}}.',
    notNow: 'Pas maintenant',
    doneAria: 'Marquer {{title}} comme fait',
    actionsFor: 'Actions pour {{title}}',
    delegate: 'Déléguer',
    findTime: 'Trouver un créneau',
    assistantFallback: 'Dream',
    notePlaceholder: 'Des consignes ?',
    noteAria: 'Note pour {{name}} à propos de {{title}}',
    delegateSend: 'Confier à {{name}}',
    pickHint: 'Touchez une tâche pour la confier ou lui trouver un créneau',
    pickedFor: 'Pour : {{title}}',
    recordVoiceNote: 'Enregistrer une note vocale',
    stopRecording: 'Arrêter l’enregistrement',
    listening: 'J’écoute…',
    transcribing: 'Je note…',
    delegationQueued: 'En attente pour {{name}}',
    delegationWorking: '{{name}} s’en occupe',
    micUnavailable: 'Le micro n’est pas disponible ici.',
    lookingForTime: 'Je regarde votre journée…',
    howAbout: 'Que diriez-vous de {{time}} ?',
    howAboutContext: 'Que diriez-vous de {{time}}, {{context}} ?',
    bookIt: 'Réserver',
    otherTimes: 'Autres moments',
    partMorning: 'Matin',
    partAfterLunch: 'Après le déjeuner',
    partAfternoon: 'Après-midi',
    partEndOfDay: 'Fin de journée',
    booked: '{{time}} réservé dans votre calendrier.',
    noCalendar: 'Aucun calendrier n’est connecté, donc rien à réserver.',
    noFreeTime: 'Plus de temps libre aujourd’hui.',
    noFreeTimeInPart: 'Pas de temps libre à ce moment de la journée.',
    calendarUnavailable: 'Votre calendrier n’est pas joignable pour le moment.',
  },
  booking: {
    noKey: 'Aucune clé de réservation fournie',
    invalidData: 'Données de réservation invalides',
    loadFailed:
      'Impossible de charger les informations de réservation. Le lien a peut-être expiré ou est invalide.',
    loading: 'Chargement de vos informations de réservation...',
    errorTitle: 'Erreur de lien de réservation',
    goHome: "Aller à l'accueil",
    noDataTitle: 'Aucune donnée de réservation',
    noDataBody: 'Impossible de charger les informations de réservation.',
    title: 'Finalisez votre réservation de vol',
    redirectBody:
      'Vous allez être redirigé pour finaliser votre réservation de vol.',
    provider: 'Prestataire de réservation',
    providerFallback: 'Prestataire de réservation de vols',
    redirectingIn: 'Redirection automatique dans {{seconds}} secondes...',
    continueTo: 'Continuer vers {{provider}}',
    bookingSiteFallback: 'le site de réservation',
    disclaimer:
      'Vous serez redirigé vers le site du prestataire pour finaliser votre achat. Ce lien est sécurisé et expirera après 24 heures.',
  },
  artifact: {
    proofTeamSaw: 'Ce que notre équipe a vu',
    proofScreenshotOf: 'Capture {{n}} sur {{total}}',
    proofEmailHeading: 'E-mail de confirmation',
    proofEmailReceived: 'Reçu {{when}}',
    proofPrivate:
      'Seules les personnes disposant de ce lien peuvent voir cette page.',
    loading: 'Chargement...',
    unableToLoad: 'Chargement impossible',
    noShareToken: 'Aucun jeton de partage fourni',
    loadFailed: "Impossible de charger l'élément",
    gettingLivePrices: 'Récupération des prix en direct',
    linkExpired: 'Ce lien a expiré. Veuillez en demander un nouveau.',
    linkInvalid: "Ce lien est invalide ou l'élément n'existe plus.",
    genericError: 'Une erreur est survenue. Veuillez réessayer plus tard.',
    sessionExpired:
      "Cette session a expiré car vous n'étiez pas connecté. Veuillez demander à Dream de renvoyer le lien.",
    linkExpiredShort: 'Ce lien a expiré.',
    alreadyResponded: 'Une réponse a déjà été apportée.',
    submitFailed: "Échec de l'envoi de la réponse. Veuillez réessayer.",
    responseSubmitted: 'Réponse envoyée',
    responseSubmittedBody:
      'Votre réponse a été enregistrée. Vous pouvez fermer cette page.',
    bookingNow: 'Réservation en cours',
    bookingNowBody:
      'Un instant — nous réservons ceci pour vous. Vous recevrez la confirmation dans le chat ; vous pouvez fermer cette page.',
    booked: 'Réservé',
    bookedBody:
      "C'est fait. La confirmation est dans votre chat. Vous pouvez fermer cette page.",
    bookedReference: 'Référence {{reference}}',
    notBooked: 'Non réservé',
    notBookedBody:
      "Rien n'a été débité. Dream a été informé et reviendra vers vous dans le chat.",
    bookingUnknown: 'Vérification de la réservation',
    bookingUnknownBody:
      "La réservation n'a pas pu être confirmée immédiatement. Dream vérifie auprès de l'opérateur et vous tiendra informé dans le chat — rien d'autre n'est requis de votre part.",
    paymentReceived: 'Paiement reçu',
    paymentReceivedBody:
      'Nous confirmons votre paiement — vos crédits seront ajoutés dans un instant. Vous pouvez fermer cette page.',
    topUpComplete: 'Recharge effectuée',
    topUpCreditsAdded:
      '{{credits}} crédits ont été ajoutés à votre compte. Vous pouvez fermer cette page.',
    topUpAlreadyDone:
      'Cette recharge a déjà été effectuée. Vous pouvez fermer cette page.',
    topUpMissingDetails:
      'Les détails de ce lien de recharge sont manquants. Veuillez en demander un nouveau.',
    checkoutFailed: 'Échec du démarrage du paiement. Veuillez réessayer.',
    linkExpiredAskDream:
      "Ce lien a expiré. Veuillez demander à Dream d'en envoyer un nouveau.",
    topUpAlreadyCompleted: 'Cette recharge a déjà été effectuée.',
    topUpFailed: "Échec de la recharge. Votre carte n'a pas été débitée.",
    continueSecureCheckout: 'Continuer vers le paiement sécurisé',
    cardSetupFailed:
      "Échec de l'enregistrement de la carte. Veuillez réessayer.",
    cardAdded: 'Carte ajoutée',
    cardAddedBody:
      'Votre carte est enregistrée. Votre secrétaire pourra désormais la recharger lorsque vous approuvez un achat. Vous pouvez fermer cette page.',
    subscriptionActive: 'Abonnement actif',
    subscriptionActiveBody:
      'Votre forfait est configuré et vos crédits ont été ajoutés. Vous pouvez fermer cette page.',
    subscriptionPendingBody:
      'Nous confirmons votre abonnement — vos crédits seront ajoutés dans un instant. Vous pouvez fermer cette page.',
    selectPlan: 'Choisissez un forfait',
    popular: 'POPULAIRE',
    yourPlan: 'Votre forfait',
    loadingShort: 'Chargement...',
    choosePlan: 'Choisir {{name}}',
    addCardOnly: 'Ou ajoutez simplement une carte sans forfait',
    noContent: 'Aucun contenu disponible.',
    alreadyHandled: 'Déjà traité',
    alreadyHandledTitled:
      "« {{title}} » a déjà reçu une réponse, aucune action n'est nécessaire ici. Vous pouvez fermer cette page.",
    alreadyHandledUntitled:
      "Cette demande a déjà reçu une réponse, aucune action n'est nécessaire ici. Vous pouvez fermer cette page.",
    secureLoginCancelled: 'Connexion annulée',
    secureLoginCancelledLead: 'Connexion',
    secureLoginCancelledAccent: 'annulée',
    secureLoginDone: 'Connecté',
    secureLoginDoneAccent: 'en toute sécurité',
    secureLoginDoneBody:
      'Dream peut poursuivre votre connexion. Vous pouvez fermer cette page.',
    secureCardSaved: 'Carte enregistrée',
    secureCardSavedAccent: 'en toute sécurité',
    secureCardSavedBody:
      "Votre carte est stockée en toute sécurité et n'est jamais partagée avec votre secrétaire. Vous pouvez fermer cette page.",
    secureLoginCancelledBody:
      "Aucune information n'a été enregistrée. Vous pouvez fermer cette page et redemander à votre secrétaire quand vous le souhaitez.",
  },
  wizard: {
    stepLabelPrivacy: 'Votre vie privée',
    mobileStepPrivacy: 'Vie privée',
    getStarted: 'Commencer',
    close: 'Fermer',
    privacyStep: {
      title: 'Déléguez les corvées, pas vos données',
      lede: 'Une secrétaire de haut niveau qui gère votre quotidien et protège vos données.',
      point1: 'Nous n’utilisons pas vos données pour entraîner nos modèles',
      point2: 'Nous ne vendons jamais vos données à qui que ce soit',
      point3:
        'Quand vous connectez une application, vous pouvez toujours voir comment votre secrétaire l’utilise',
      point4:
        'Supprimé veut dire supprimé. Vos applications, votre compte : si ça doit disparaître, ça disparaît',
      point5: 'Dream ne conserve aucun e-mail que vous recevez',
      learnMore: 'Je veux en savoir plus',
      analyticsTitle: 'Aidez-nous à améliorer votre secrétaire',
      analyticsBody:
        'Aidez-nous à évaluer les performances de votre secrétaire. Les résultats sont anonymes, personne ne lit vos conversations.',
      modalTitle: 'Votre vie privée, expliquée simplement',
      rights: {
        memoryTitle: 'Le droit de gérer la mémoire de votre secrétaire',
        memoryBody:
          'Vous pouvez voir les informations importantes que votre secrétaire retient sur vous. Vous pouvez les corriger ou lui demander de les supprimer.',
        conversationTitle: 'Le droit à une conversation privée',
        conversationBody:
          'Ce que vous dites à votre secrétaire reste privé. Nous ne partageons une conversation que si la loi nous y oblige. Les techniciens de Dream ne peuvent lire une conversation que si vous avez signalé un bug, et nous vous en informons.',
        dataUseTitle: 'Le droit de savoir comment nous utilisons vos données',
        dataUseBody: 'Nous ne vendons pas vos données personnelles.',
        knowTitle: 'Le droit de savoir ce que Dream sait de vous',
        knowBody:
          'Vous pouvez nous demander quelles données nous avons sur vous et en recevoir une copie.',
        correctTitle: 'Le droit de faire corriger les erreurs',
        correctBody:
          'Si une information que nous avons sur vous est fausse, vous pouvez nous demander de la corriger.',
        deleteTitle: 'Le droit de supprimer vos données',
        deleteBody:
          'Vous pouvez nous demander de supprimer vos données. Nous devrons peut-être en garder certaines si la loi l’exige.',
        portabilityTitle: 'Le droit d’emporter vos données',
        portabilityBody:
          'Vous pouvez nous demander une copie de vos données dans un format que vous pourrez utiliser ailleurs.',
        limitTitle: 'Le droit de limiter l’utilisation de vos données',
        limitBody:
          'Vous pouvez nous demander d’arrêter ou de réduire l’utilisation de vos données, tant que l’application peut encore fonctionner.',
        accessTitle: 'Le droit de savoir à quoi votre secrétaire a accès',
        accessBody:
          'Vous pouvez voir à quels comptes et services votre secrétaire a accès. Vous pouvez retirer cet accès quand vous voulez.',
        providersTitle:
          'Le droit de savoir qui d’autre a besoin de vos données',
        providersBody:
          'Dream s’appuie sur quelques prestataires techniques. Ils sont contrôlés pour vérifier qu’ils respectent le RGPD.',
        securityTitle: 'Le droit à une sécurité raisonnable',
        securityBody:
          'Nous protégeons vos données et empêchons toute personne non autorisée d’y accéder.',
      },
    },
    stepLabel1: 'Connectez vos comptes',
    stepLabel2: 'Briefing quotidien',
    stepLabel3: 'Intégrations',
    stepLabel4: 'Votre secrétaire',
    stepLabel5: 'Premières tâches',
    mobileStep1: 'Comptes',
    mobileStep2: 'Briefing',
    mobileStep3: 'Intégrations',
    mobileStep4: 'Secrétaire',
    mobileStep5: 'Premières tâches',
    briefingSub1: 'Ce que c’est',
    briefingSub2: 'Quand il arrive',
    briefingSub3: 'Autres routines',
    assistantSub1: 'Nom',
    assistantSub2: 'E-mail',
    assistantSub3: 'Carte',
    assistantSub4: 'L’équipe',
    taskSub1: 'Déjà fait',
    taskSub2: 'Parrainages',
    taskSub3: 'Votre première tâche',
    continue: 'Continuer',
    letsGetStarted: 'C’est parti',
    back: 'Retour',
    stepOf: '{{label}} · {{step}} sur {{total}}',
    eyebrow: 'Étape {{step}} sur {{total}} · {{label}}',
    oneMoment: 'Un instant…',
    loadingSetup: 'Chargement de votre configuration…',
    linkErrorTitle: 'Hmm, ce lien n’a pas fonctionné',
    missingToken:
      'Ce lien est incomplet. Demandez un nouveau lien à votre secrétaire.',
    loadFailed:
      'Une erreur est survenue lors du chargement de votre configuration.',
    genericError: 'Une erreur est survenue. Réessayez.',
    allSetTitle: 'Tout est prêt',
    allSetBody:
      'Retournez à votre conversation WhatsApp avec {{name}} — il vous attend.',
    openWhatsApp: 'Ouvrir WhatsApp',
    privacy: 'Confidentialité',
    terms: 'Conditions',
    openingWhatsAppToast: 'Ouverture de WhatsApp — « {{task}} » avec {{name}}.',
    oauthMissingScopes:
      'Votre compte est connecté. L’accès {{scopes}} n’a pas été accordé, votre secrétaire ne pourra donc pas vous aider dans {{area}} sur ce compte. Vous pouvez accorder l’accès à tout moment en reconnectant le compte.',
    oauthMissingAreaSingle: 'ce domaine',
    oauthMissingAreaMulti: 'ces domaines',
    oauthNoMailboxTitle: 'Connecté, mais ce compte n’a pas de boîte Gmail',
    oauthNoMailbox:
      'Google indique que Gmail n’est pas activé pour ce compte (son Workspace n’inclut plus Gmail, ou il s’agit d’un identifiant Google associé à une adresse non Gmail). Votre secrétaire pourra utiliser son agenda et ses contacts, mais pas lire, rechercher ni rédiger d’e-mails depuis ce compte. Si vos e-mails sont ailleurs, connectez aussi ce compte-là.',
    listAnd: 'et',
    oauthAlreadyLinkedOther:
      'Ce compte e-mail est déjà lié à un autre compte, il n’a donc pas pu être ajouté ici. Connectez-en un autre, ou contactez-nous si vous pensez qu’il s’agit d’une erreur.',
    oauthExpired:
      'Ce lien de configuration a expiré. Demandez-en un nouveau à votre secrétaire sur WhatsApp.',
    oauthInvalidToken:
      'Ce lien de configuration n’est plus valide. Demandez-en un nouveau à votre secrétaire sur WhatsApp.',
    oauthError:
      'Une erreur est survenue lors de la connexion de ce compte. Veuillez réessayer.',
    halfModalTitle: 'Dream ne voit que la moitié de votre semaine',
    halfModalWork:
      'Sans votre agenda professionnel, il proposera des créneaux où vous n’êtes pas réellement disponible et manquera ce qui compte le plus.',
    halfModalPersonal:
      'Sans votre agenda personnel, il réservera sur vos soirées et week-ends comme s’ils étaient libres.',
    connectWork: 'Connecter le pro',
    connectPersonal: 'Connecter le perso',
    carryOnAnyway: 'Continuer quand même',
    noAccount: {
      title: 'Continuer sans compte ?',
      needs:
        '{{name}} a besoin de voir votre agenda et vos e-mails pour vous aider au mieux.',
      impact:
        'Il ne pourra pas vérifier vos disponibilités, ce qui pourrait créer des conflits dans votre emploi du temps.',
      changeLater:
        'Si vous êtes sûr, choisissez « continuer » ci-dessous. Vous pourrez changer d’avis plus tard.',
      understandContinue: 'J’ai compris, continuer',
      goBackConnect: 'Revenir et connecter',
    },
    previewCap: 'Ce qui arrive à',
    previewMorning:
      'Bonjour{{name}} — voici votre journée. Trois réunions, deux réponses encore dues.',
    previewFullBriefing: 'Briefing complet pour chaque réunion',
    previewEveningRoundUp: 'Récap du soir des choses en suspens',
    previewOwedReplies: 'Réponses que vous devez, et qu’on vous doit',
    connect: {
      title: 'Connectez vos comptes',
      ledeWide:
        'Connectez votre e-mail et votre agenda pour que {{name}} puisse suivre vos tâches et repérer les conflits de calendrier.',
      ledeNarrow:
        'Connectez votre e-mail et votre agenda pour que {{name}} voie toute votre semaine.',
      ledeExtra:
        'Ajoutez votre compte personnel et votre compte professionnel pour qu’il voie toute votre semaine.',
      personal: 'Personnel',
      personalSub: 'Votre boîte mail et votre agenda personnels.',
      work: 'Professionnel',
      workSub: 'Là où se trouvent la plupart de vos réunions.',
      connected: 'Connecté',
      notConnected: 'Non connecté',
      connectedAccount: 'Compte connecté',
      disconnectAria: 'Déconnecter {{account}}',
      thisAccount: 'ce compte',
      addAnother: 'En ajouter un autre',
      opening: 'Ouverture…',
      openConnectError: 'Impossible d’ouvrir la page de connexion.',
      disconnectError: 'Impossible de déconnecter le compte.',
      adminNoteTitle: 'Impossible de connecter votre compte professionnel ?',
      adminNoteBody:
        'Si vous avez été renvoyé directement sans écran de consentement, il se peut que l’administrateur de votre espace de travail doive d’abord approuver Dream — voici un guide à lui envoyer.',
      adminGuideShareTitle:
        'Pourquoi Dream a besoin d’accéder à votre compte Google',
      sendAdminGuide: 'Envoyer le guide à votre admin',
      guideLinkCopied: 'Lien copié — envoyez-le à votre admin',
      viewGuide: 'Voir le guide',
      dismiss: 'Fermer',
      connectionDidntFinish: 'Cette connexion n’a pas abouti',
      neverSend: 'Il n’enverra jamais d’e-mail depuis votre compte.',
      disclaimer:
        'Nous prenons en charge les comptes Gmail, Google Workspace et Outlook.',
      noAccountHint: 'Vous préférez ne pas en connecter ?',
      carryOnWithout: 'Continuer sans compte e-mail',
      chooseTitle: 'Connecte un compte e-mail',
      chooseLede:
        'Gmail ou Outlook. Je devine d’après l’adresse s’il est professionnel ou personnel, et vous pouvez le changer.',
      gmail: 'Gmail',
      outlook: 'Outlook',
      workNeededNote:
        '{{org}} a besoin de votre e-mail professionnel : connectez celui-là.',
      kindAria: 'Professionnel ou personnel',
      changeKindError: 'Impossible de changer le type de compte. Réessayez.',
      kindLabel: 'Quel type de compte est-ce ?',
      professional: 'Professionnel',
      professionalSub: 'Ton e-mail et ton agenda professionnels.',
      neededFor: 'Requis pour {{org}}',
      providerLabel: 'Chez quel fournisseur ?',
      google: 'Google',
      microsoft: 'Microsoft',
      other: 'Autre',
      otherNoteWork:
        '{{org}} a besoin d’un compte professionnel Google ou Microsoft. Si ton e-mail professionnel est chez un autre fournisseur, demande à ton équipe IT.',
      otherNote:
        'Pour l’instant, {{name}} fonctionne avec les comptes Google et Microsoft. Tu peux continuer sans compte et le connecter plus tard.',
    },
    briefing: {
      whatTitle: 'Réveillez-vous avec une longueur d’avance',
      whatLedeWide:
        'Chaque matin, un seul message avec tout ce que vous auriez sinon appris trop tard.',
      whatLedeNarrow: 'Un message chaque matin, sur WhatsApp.',
      morningLede: 'Bonjour{{name}} — voici votre journée.',
      line1: 'Vol pour Amsterdam, 11 h 05 — carte d’embarquement jointe',
      line2: 'Trois réunions, toutes briefées avec photos',
      line3: 'Deux réponses encore dues, brouillons prêts',
      line4: 'Anniversaire d’Angie jeudi',
      whatFoot: 'Arrive sur WhatsApp, chaque matin.',
      whenTitle: 'Quand doit-il arriver ?',
      whenLedeWide:
        'Choisissez une heure qui vous convient — vous pourrez la changer quand vous voulez.',
      whenLedeNarrow:
        'Choisissez une heure — vous pourrez la changer plus tard.',
      arrivesAt: 'Arrive à',
      onWhatsApp: 'Sur WhatsApp',
      earlier15: '15 minutes plus tôt',
      later15: '15 minutes plus tard',
      deliveryTimeAria: 'Heure de livraison du briefing',
      includeInBriefing: 'Inclure dans le briefing',
      fullMeetingBriefing: 'Briefing complet des réunions',
      alwaysOn: 'Toujours actif',
      fullMeetingSub:
        'Photos, comment on vous a présenté, et comment prononcer le nom de chacun.',
      routinesTitle: 'Ce que votre secrétaire peut aussi gérer',
      routinesLede:
        'Tout est activé au départ — désactivez ce que vous ne voulez pas.',
      eveningTitle: 'Récap du soir des choses en suspens',
      eveningSub:
        'Un court message en fin de journée : ce qui est passé à la trappe, ce que vous aviez promis de faire, et ce qui vous attend demain matin.',
      owedTitle: 'Suivi des réponses dues',
      owedSub:
        'Il garde le compte de qui vous attend et de qui vous attendez, et vous relance avant que ce soit gênant.',
      labellingTitle: 'Trier et étiqueter votre boîte de réception',
      labellingSub:
        'Étiquette ce qui arrive — reçus, newsletters, ce qui demande votre attention — et écarte le bruit. Votre boîte est déjà bien tenue ? Laissez ceci désactivé.',
    },
    integrations: {
      title: 'Branchez Dream sur tout le reste',
      ledeWide:
        '{{name}} peut travailler dans les outils que vous utilisez déjà, en lisant ce qui s’y trouve et en faisant ce que vous feriez à la main.',
      ledeNarrow: '{{name}} travaille dans les outils que vous utilisez déjà.',
      ledeExtra:
        'Connectez ce que vous voulez maintenant, ou revenez-y plus tard.',
      alreadyConnected: 'Déjà connecté',
      whatsappRowName: 'WhatsApp',
      whatsappRowMeta: 'Là où {{name}} et vous discutez',
      spottedInEmail: 'Repéré dans vos e-mails',
      everythingElse: 'Tout le reste',
      addMore: 'En ajouter',
      showFewer: 'En voir moins',
      showAll: 'Tout afficher ({{count}})',
      connected: 'Connecté',
      connect: 'Connecter',
      comingSoon: 'Bientôt disponible',
      cancel: 'Annuler',
      close: 'Fermer',
      verifying: 'Vérification…',
      personal: 'Personnel',
      work: 'Professionnel',
      connectedAccount: 'Compte connecté',
      connectApp: 'Connecter {{name}}',
      apiKeyBody: '{{hint}} et {{name}} la vérifiera avant de l’enregistrer.',
      apiKeyDefaultHint: 'Collez votre clé API',
      apiKeyPlaceholder: 'Clé API {{name}}',
      connectError: 'Connexion impossible. Réessayez.',
      apps: {
        slack: {
          sub: 'Messages et canaux',
          spottedSub:
            'Surveille les canaux importants, publie des mises à jour en votre nom et vous résume ce que vous avez manqué.',
        },
        hubspot: {
          sub: 'Contacts et affaires',
          spottedSub:
            'Consigne les appels et les notes, tient à jour affaires et contacts, et relance les prochaines étapes pour vous.',
        },
        attio: {
          sub: 'Fiches CRM',
          spottedSub:
            'Tient à jour les fiches et les nouveaux contacts après chaque appel et e-mail, sans que vous fassiez la gestion.',
        },
        linear: {
          sub: 'Tickets et projets',
          spottedSub:
            'Crée, met à jour et relance les tickets pour que vos projets avancent pendant que vous êtes ailleurs.',
        },
        notion: {
          sub: 'Pages, listes et bases de données',
          spottedSub:
            'Lit vos listes de tâches partagées, ajoute et coche des éléments, et crée ou met à jour des pages et bases de données pour vous.',
        },
        asana: {
          sub: 'Tâches et projets',
          spottedSub:
            'Crée et met à jour des tâches à partir de vos conversations et relance ce qui bloque un projet.',
        },
        todoist: {
          sub: 'Votre liste de tâches',
          spottedSub:
            'Ajoute des tâches directement depuis vos e-mails et WhatsApp, et les coche au fur et à mesure.',
        },
        granola: {
          sub: 'Notes de réunion',
          spottedSub:
            'Transforme automatiquement vos notes de réunion en actions et relances après chaque appel.',
        },
        xero: {
          sub: 'Factures et dépenses',
          spottedSub:
            'Relance les factures impayées, classe les reçus et garde un œil sur les dépenses sans que vous l’ouvriez.',
        },
        lusha: {
          sub: 'Enrichissement de contacts',
          spottedSub:
            'Trouve les coordonnées des personnes que vous voulez joindre, au moment où vous en avez besoin.',
          keyHint: 'Collez votre clé API Lusha',
        },
        devin: {
          sub: 'Tâches d’ingénierie',
          spottedSub:
            'Confie des tâches d’ingénierie, les suit jusqu’au bout et vous prévient quand elles ont besoin de vous.',
          keyHint: 'Collez votre clé API Devin',
        },
      },
    },
    assistant: {
      nameTitle: 'Rencontrez votre secrétaire',
      nameLedeWide:
        'Il se présentera sous ce nom. Changez-le si vous préférez l’appeler autrement.',
      nameLedeNarrow: 'Changez-le si vous préférez l’appeler autrement.',
      nameLabel: 'Nom de votre secrétaire',
      nameRequired: 'Donnez un nom à votre secrétaire.',
      emailTitle: '{{name}} a sa propre adresse e-mail',
      emailLede:
        'Il peut parler au monde en votre nom — et ne répondra jamais qu’à vous.',
      sigQuote:
        '…J’ai proposé trois options pour jeudi. Dites-moi laquelle vous convient et je confirme.',
      sigRole: 'Secrétaire',
      sigRoleTo: 'Secrétaire de {{name}}',
      whenEmail: 'Quand peut-il envoyer des e-mails ?',
      expressPermission: 'Seulement avec mon autorisation expresse',
      cardTitle: 'Et sa propre carte',
      cardLede:
        'Pour réserver et acheter en votre nom. Elle ne dépense jamais sans votre accord.',
      cardKind: 'Virtuelle · Usage unique',
      cardholder: 'Titulaire',
      expires: 'Expire',
      whenSpend: 'Quand peut-il dépenser ?',
      teamTitle: 'Il y a des personnes derrière {{name}}',
      teamLedeWide:
        'Certaines choses ne peuvent pas être faites par un logiciel. Dans ce cas, une personne formée de notre équipe prend le relais — et {{name}} reste votre interlocuteur.',
      teamLedeNarrow:
        'Quand le logiciel ne peut pas le faire, une vraie personne prend le relais. {{name}} reste votre interlocuteur.',
      whatTheyDo: 'Ce qu’ils feront',
      teamItem1:
        'Appeler un restaurant, une clinique ou un lieu sans système de réservation',
      teamItem2: 'Naviguer sur un site web qui résiste à l’automatisation',
      teamItem3: 'Relancer quelque chose qui nécessite qu’un humain insiste',
      playSample: 'Écouter l’appel d’exemple',
      pauseSample: 'Mettre en pause l’appel d’exemple',
      hearCallIn: 'Écouter l’appel en',
      callLanguage: {
        en: 'Anglais',
        de: 'Allemand',
        fr: 'Français',
        it: 'Italien',
        es: 'Espagnol',
      },
      audioTitle: 'Écoutez un vrai appel : réservation d’une table',
    },
    alreadyDone: {
      putToWorkTitle: 'Mettez {{name}} au travail',
      putToWorkLede:
        'Première mission : rédiger les réponses et relances pour ce qui attend dans votre boîte mail.',
      firstDrafts: 'Vos premiers brouillons',
      firstDraftsSub:
        'Prêts en quelques minutes. {{name}} n’envoie jamais — c’est vous qui le faites.',
      draftCta: 'Rédiger mes premières réponses',
      hitASnag: '{{name}} a rencontré un problème',
      snagLede:
        'Je n’ai pas pu terminer vos premiers brouillons — rien de grave.',
      snagLine1: 'Je continue de rédiger à mesure que les e-mails arrivent',
      snagLine2: 'Rien ne part sans vous',
      tryingAgain: 'Nouvelle tentative…',
      tryAgain: 'Réessayer',
      alreadyDoneTitle: 'Déjà fait',
      emptyLede:
        'Tout est à jour — rien ne nécessitait de réponse pour le moment.',
      emptyLine1: 'Je rédige à mesure que les e-mails arrivent',
      emptyLine2: 'Tout attend dans votre dossier brouillons',
      readyLede: 'Terminé — vos brouillons sont prêts.',
      readyLine1: 'En attente dans votre dossier brouillons',
      readyLine2: 'Modifiez-les vous-même, ou demandez-moi des changements',
      onItTitle: '{{name}} s’en occupe',
      now: 'maintenant',
      working: 'En cours',
      workingLede:
        'Je parcours votre boîte mail — vos premiers brouillons prennent quelques minutes.',
      workingLine1:
        'Ils attendront dans votre dossier brouillons — rien ne part sans vous',
      workingLine2: 'Je vous préviendrai sur WhatsApp dès qu’ils seront prêts',
      workingFoot: 'Pas besoin d’attendre ici — vous pouvez continuer.',
    },
    referrals: {
      title: 'Parrainez vos amis, déléguez davantage',
      lede1: 'Commencez avec {{amount}} de crédits par mois, gratuitement.',
      lede2:
        'Parrainez un ami : vous recevez {{amount}} de crédits, et lui aussi.',
      lede1V3:
        'Votre premier mois de Dream est gratuit : utilisation illimitée, offerte.',
      lede2V3:
        'Invitez un ami et vous recevez tous les deux de l’utilisation bonus sur Dream.',
      invitesNote:
        'Vous avez {{count}} invitations ce mois-ci, choisissez quelqu’un qui a vraiment besoin d’une secrétaire.',
      yourInviteLink: 'Votre lien d’invitation',
      copied: 'Copié',
      copyLink: 'Copier le lien',
      copyError:
        'Impossible de copier votre lien — sélectionnez-le et copiez-le.',
    },
    tasks: {
      loaderTitle: 'Faisons connaissance',
      loaderLede:
        'Laissez-moi un instant avec votre boîte mail et votre agenda. Voici ce que j’ai repéré jusqu’ici.',
      spline1: 'Lecture du rythme de votre semaine',
      spline2: 'Compréhension de vos habitudes de voyage',
      spline3: 'Analyse de vos préférences de réunion',
      spline4: 'Repérage des personnes à qui vous parlez le plus',
      spline5: 'Identification des e-mails qui comptent vraiment pour vous',
      spline6: 'Repérage de vos réservations et lieux habituels',
      spline7: 'Cartographie de vos matinées et de vos soirées',
      spline8: 'Détection des abonnements et renouvellements',
      title: 'Que doit faire {{name}} en premier ?',
      lede: 'Choisissez-en une — vous réglerez les détails dans la conversation.',
      pickOne: 'Choisissez-en une pour commencer',
      chooseAria: 'Choisir une première tâche',
      somethingElse: 'Autre chose',
      somethingElseTagline: 'Vous pouvez demander n’importe quoi',
      bookRestaurant: 'Réserver un restaurant',
      bookHaircut: 'Prendre rendez-vous chez le coiffeur',
      findFlights: 'Trouver des vols',
      yourFirstTask: 'votre première tâche',
      validation: 'Choisissez-en une pour commencer.',
      handoff: 'Ouvre votre conversation WhatsApp avec {{name}}.',
    },
  },
  // Vue invité publique d'une liste de tâches partagée (voir en.ts).
  login: {
    title: 'Connectez-vous à Dream',
    lede: 'Saisissez le numéro de téléphone que vous utilisez avec Dream et nous vous enverrons un code à usage unique par SMS.',
    phoneLabel: 'Numéro de téléphone',
    countryLabel: 'Indicatif du pays',
    countrySearchPlaceholder: 'Rechercher un pays',
    countryNoResults: 'Aucun pays ne correspond',
    sendCode: 'Recevoir un code',
    or: 'ou',
    continueWithGoogle: 'Continuer avec Google',
    continueWithMicrosoft: 'Continuer avec Microsoft',
    newHere:
      "Nouveau sur Dream ? Commencez d'abord une conversation avec votre secrétaire sur WhatsApp.",
    errors: {
      empty: 'Saisissez votre numéro de téléphone.',
      malformed:
        'Cela ne ressemble pas à un numéro de téléphone. Utilisez uniquement des chiffres.',
      tooShort:
        'Ce numéro est trop court pour {{selectedCountry}} ({{selectedCode}}).',
      tooLong:
        'Ce numéro est trop long pour {{selectedCountry}} ({{selectedCode}}).',
      countryMismatch:
        'Ce numéro commence par {{typedCode}} ({{typedCountry}}), mais {{selectedCountry}} ({{selectedCode}}) est sélectionné. Choisissez {{typedCountry}} dans la liste ou retirez le préfixe.',
      invalidForCountry:
        "Ce n'est pas un numéro valide pour {{selectedCountry}}. Vérifiez-le et réessayez.",
    },
  },
  todoGuest: {
    pageTitle: 'Liste de tâches partagée · Dream',
    banner:
      '<strong>{{inviter}}</strong> vous a invité à modifier la liste <strong>{{list}}</strong> avec Dream',
    members_one: '{{count}} membre',
    members_other: '{{count}} membres',
    you: '{{name}} (vous)',
    empty: 'Rien sur cette liste pour le moment.',
    completedByYou: 'Terminées par vous',
    task: {
      from: 'de {{name}}',
      fromGuest: 'de {{name}} (invité)',
      editedBy: 'modifiée par {{name}}',
      assignedToYou: 'Vous',
      unassigned: 'Non attribuée',
      complete: 'Marquer comme terminée',
      reopen: 'Marquer comme non terminée',
      notYours:
        'Seule la personne à qui cette tâche est attribuée peut la cocher',
    },
    newTask: {
      button: 'Nouvelle',
      title: 'Nouvelle tâche',
      descriptionLabel: 'Tâche',
      descriptionPlaceholder: 'Décrivez votre tâche',
      dueDateLabel: 'Ajouter une échéance',
      assignLabel: 'Attribuer',
      unassigned: 'Non attribuée',
      priorityLabel: 'Ajouter une priorité',
      noPriority: 'Sans priorité',
      priority: {
        high: 'Priorité haute',
        medium: 'Priorité moyenne',
        low: 'Priorité basse',
      },
      submit: 'Ajouter la tâche',
      submitting: 'Ajout…',
      error: 'Impossible d’ajouter cette tâche. Veuillez réessayer.',
    },
    errors: {
      updateFailed:
        'Impossible de mettre à jour cette tâche. Veuillez réessayer.',
    },
    verify: {
      titleWhatsApp: 'Consultez WhatsApp pour votre code',
      titleEmail: 'Consultez vos e-mails pour votre code',
      bodyWhatsApp:
        'Pour ouvrir la liste <strong>{{list}}</strong> de <strong>{{inviter}}</strong>, saisissez le code à 6 chiffres que nous venons d’envoyer au <strong>{{destination}}</strong> sur WhatsApp.',
      bodyEmail:
        'Pour ouvrir la liste <strong>{{list}}</strong> de <strong>{{inviter}}</strong>, saisissez le code à 6 chiffres que nous venons d’envoyer à <strong>{{destination}}</strong>.',
      codeLabel: 'Code de vérification',
      submit: 'Ouvrir la liste',
      checking: 'Vérification…',
      sending: 'Envoi de votre code…',
      resendIn_one: 'Renvoyer le code dans {{count}} seconde',
      resendIn_other: 'Renvoyer le code dans {{count}} secondes',
      resend: 'Renvoyer le code',
      sendCode: 'M’envoyer un code',
      errors: {
        invalid: 'Ce code est incorrect. Réessayez.',
        invalidWithAttempts_one:
          'Ce code est incorrect. Il vous reste {{count}} essai.',
        invalidWithAttempts_other:
          'Ce code est incorrect. Il vous reste {{count}} essais.',
        expired: 'Ce code a expiré. Demandez-en un nouveau.',
        tooManyAttempts:
          'Trop de tentatives incorrectes. Demandez un nouveau code.',
        sendFailed:
          'Impossible d’envoyer votre code pour le moment. Veuillez réessayer.',
        generic: 'Une erreur s’est produite. Veuillez réessayer.',
      },
    },
    invalid: {
      title: 'Ce lien a expiré. Vous devrez être invité·e à nouveau.',
      body: 'Obtenez votre propre secrétaire pour accéder aux listes, et bien plus.',
      cta: 'Inscrivez-vous sur WhatsApp',
    },
    nudge: {
      title: 'Faites encore plus avec votre propre Secrétaire IA',
      body: 'Obtenez une secrétaire de classe mondiale, épaulée par de vraies secrétaires formées, prête à gérer votre quotidien.',
      getYourOwnPa: 'Obtenir ma propre secrétaire',
      phonePrompt:
        'Commencez à discuter avec votre secrétaire sur WhatsApp — saisissez votre numéro de téléphone',
      phonePlaceholder: 'Votre numéro de téléphone',
      phoneSubmit: 'Continuer sur WhatsApp',
      phoneInvalid:
        "Veuillez saisir un numéro de téléphone valide, avec l'indicatif du pays.",
      outcome: {
        sent: "C'est fait — ouvrez WhatsApp, votre nouvelle secrétaire vient de vous écrire.",
        already_on_dream:
          'Ce numéro possède déjà un compte Dream. Ouvrez WhatsApp pour continuer à discuter avec votre secrétaire.',
        already_invited:
          'Vous avez déjà commencé votre inscription — ouvrez WhatsApp pour reprendre où vous en étiez.',
      },
      error: "Une erreur s'est produite. Veuillez réessayer.",
      later: 'Peut-être plus tard',
    },
  },
  expenseReview: {
    headingSingle: 'Votre demande de remboursement',
    headingMulti: 'Vos demandes de remboursement',
    subSingle:
      'Elle n’a pas encore été envoyée. Choisissez « Envoyer » ou demandez à votre secrétaire quand vous êtes prêt.',
    subMulti:
      'Elles n’ont pas encore été envoyées. Choisissez « Envoyer » ou demandez à votre secrétaire quand vous êtes prêt.',
    alreadySubmittedSingle: 'Cette dépense a déjà été envoyée.',
    alreadySubmittedMulti: 'Ces dépenses ont déjà été envoyées.',
    empty: 'Aucune dépense dans cette vérification.',
    submit: 'Envoyer',
    submitting: 'Envoi…',
    submitAll: 'Tout envoyer ({{count}})',
    submitSome: 'Envoyer {{selected}} sur {{total}}',
    close: 'Fermer',
    notNow: 'Pas maintenant',
    error: 'Impossible de joindre Dream. Veuillez réessayer.',
    include: 'Inclure {{vendor}}',
    thisExpense: 'cette dépense',
    unknownVendor: 'Fournisseur inconnu',
    amountMissing: 'Montant manquant',
    duplicate:
      'Ressemble à un doublon d’une dépense déjà saisie (réf. {{ref}}).',
    rows: {
      settledOnCard: '{{amount}} sur la carte',
      inYourAccounts: 'Ouvrir dans votre comptabilité',
    },
    paymentMethod: {
      company_card: 'Carte de l’entreprise',
      personal_card: 'Carte personnelle (remboursement)',
    },
    status: {
      draft: 'Brouillon',
      awaiting_info: 'Infos manquantes',
      awaiting_confirmation: 'Prête à enregistrer',
      approved: 'Approuvée',
      submitted: 'Enregistrée',
      failed: 'Échec de l’enregistrement',
      discarded: 'Abandonnée',
    },
    receipts: {
      none: 'Aucun reçu joint',
      fallbackName: 'Reçu {{n}}',
      openInDream: 'Ouvrez Dream pour voir le fichier',
    },
  },
};

export default fr;
